<div class="container">
  @if(showLoader) {
    <div class="loader-wrapper" [@fadeOut] aria-hidden="true">
      <img src="/assets/animate/beaker-loader-dark.gif" alt="" />
      <p class="loading-text">Fetching careers that best fit you…</p>
    </div>
  } @else {
    <div class="content-div" (scroll)="onScroll()" [@slideUp] #contentDiv>
      <aside aria-label="Checklist Items">
        <app-left-bar [edgeAssessmentId] = "edgeAssessmentId" ></app-left-bar>
      </aside>
      <div class="result-page-wrapper">
        <app-result-page 
          (bookmarkEmitter)="toggleBookmark($event)"
          (careerSelectEmitter)="goToCareerDetails($event)"
        ></app-result-page>
      </div>
    </div>
  }
</div>
